import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { CollectionIntroItems } from '../../../Marketing/CollectionIntro/collectionIntro';

export const EmptyCart = ({ label, subLabel, cards }) => (
  <>
    <div className='my-10'>
      <Label
        size='2xl'
        weight='bold'
        text={label?.text}
      />
      <Label text={subLabel.text} />
    </div>
    <div className='w-full grid grid-cols-2 xl:grid-cols-4 gap-3'>
      <CollectionIntroItems cards={cards} />
    </div>
  </>
);
